module.exports = __webpack_public_path__ + "static/img/fc-3.bc38e91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/harmony-home/fc-3.jpg
// module id = VDfi
// module chunks = 1 2